import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "menuTop" }
const _hoisted_2 = ["data-text"]
const _hoisted_3 = ["data-text"]
const _hoisted_4 = ["data-text"]

import { computed } from 'vue'
import PAGE_NAME from '@web/consts/PAGE_NAME'
import { useMenuActiveSection } from '@web/composition/useMenuActiveSection'
import { useStore } from '@web/store'
import AsBadge from '@web/platform.v3/components/AsBadge.vue'
import { careChatEnabled } from '@web/common/ExternalConfig/getters'


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'MenuTop'
},
  __name: 'top',
  setup(__props) {



const store = useStore()
const { isActiveHome, isActiveSupport, isActiveSubscriptions } = useMenuActiveSection()
const careChatUnread = computed<number>(() =>
  careChatEnabled() ? (store.getters['careChat/unreadCount'] || 0) : 0
)

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: { name: _unref(PAGE_NAME).HOME },
      class: _normalizeClass(["menuTop_item", { '-active': _unref(isActiveHome) }]),
      "data-analytics": "",
      "data-analytics-element-type": "menu_top",
      "data-analytics-element-target": { name: _unref(PAGE_NAME).HOME },
      "data-analytics-element-id": _unref(PAGE_NAME).HOME,
      "data-analytics-element-name": _ctx.$t('crumb.general')
    }, {
      default: _withCtx(() => [
        _createElementVNode("span", {
          class: "menuTop_label",
          "data-text": _ctx.$t('crumb.general')
        }, _toDisplayString(_ctx.$t('crumb.general')), 9, _hoisted_2)
      ]),
      _: 1
    }, 8, ["to", "class", "data-analytics-element-target", "data-analytics-element-id", "data-analytics-element-name"]),
    _createVNode(_component_router_link, {
      to: { name: _unref(PAGE_NAME).SUPPORT },
      class: _normalizeClass(["menuTop_item", { '-active': _unref(isActiveSupport) }]),
      "data-analytics": "",
      "data-analytics-element-type": "menu_top",
      "data-analytics-element-target": { name: _unref(PAGE_NAME).SUPPORT },
      "data-analytics-element-id": _unref(PAGE_NAME).SUPPORT,
      "data-analytics-element-name": _ctx.$t('supportCenter')
    }, {
      default: _withCtx(() => [
        _createElementVNode("span", {
          class: "menuTop_label",
          "data-text": _ctx.$t('supportCenter')
        }, _toDisplayString(_ctx.$t('supportCenter')), 9, _hoisted_3),
        _createVNode(AsBadge, {
          count: careChatUnread.value,
          inline: ""
        }, null, 8, ["count"])
      ]),
      _: 1
    }, 8, ["to", "class", "data-analytics-element-target", "data-analytics-element-id", "data-analytics-element-name"]),
    _createVNode(_component_router_link, {
      to: { name: _unref(PAGE_NAME).SUBSCRIPTIONS },
      class: _normalizeClass(["menuTop_item", { '-active': _unref(isActiveSubscriptions) }]),
      "data-analytics": "",
      "data-analytics-element-type": "menu_top",
      "data-analytics-element-target": { name: _unref(PAGE_NAME).SUBSCRIPTIONS },
      "data-analytics-element-id": _unref(PAGE_NAME).SUBSCRIPTIONS,
      "data-analytics-element-name": _ctx.$t('Subscriptions')
    }, {
      default: _withCtx(() => [
        _createElementVNode("span", {
          class: "menuTop_label",
          "data-text": _ctx.$t('Subscriptions')
        }, _toDisplayString(_ctx.$t('Subscriptions')), 9, _hoisted_4)
      ]),
      _: 1
    }, 8, ["to", "class", "data-analytics-element-target", "data-analytics-element-id", "data-analytics-element-name"])
  ]))
}
}

})